module.exports = __webpack_public_path__ + "static/img/career-course-zyts.a734df84.png";